
// src/App.tsx

import React from "react";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { useAwsSession } from "./hooks/useAwsSession";
import { useSessionExpirationWarning } from "./hooks/useSessionExpirationWarning";

import Header from "./components/Header";
import Routes from "./components/Routes";
import Main from "./pages/Main";
import { CookieBanner } from "components/CookieBanner";
import { isDevelopment } from "./const";

function App() {
  // Kick off AWS‐session initialization on login:
  useAwsSession();

  // Monitor session expiration and warn users
  useSessionExpirationWarning();

  return (
    <div className="app">
      <Header />

      {!isDevelopment ? (
        <>
          <AuthenticatedTemplate>
            <Routes />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <Main />
          </UnauthenticatedTemplate>
        </>
      ) : (
        <Routes />
      )}

      <CookieBanner />
    </div>
  );
}

export default App;
